
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Přidejte jej na plochu pro rozšířené využití a snadný přístup.`,
's224cbcec014ef6b5': `Stiskněte tlačítko Sdílet na navigačním panelu`,
's37a9e8aec5713460': `Více`,
's386eca8362ff6155': `Stiskněte Více, pokud není ikona Sdílet`,
's4e1e10a6ca408245': `Klepněte na "Přidat na plochu"`,
's6196153c4b0c1ea0': `Nainstalovat`,
's633502f7cff4f847': `Otevřete nabídku prohlížeče`,
's681e399d63311fba': `Zobrazit galerii`,
's7f0591f08e318eda': `Stiskněte Více v menu Sdílet`,
's8114bd55cae5a22b': `Stiskněte Přidat do Docku`,
's922329d6f6213590': `Přidat do Docku`,
's9af56bf005b49c74': `Projděte dolů k "Přidat na plochu"`,
'sa5ef80b4bb9b39f8': `Méně`,
'sba52286c21552a4e': `Nainstalujte si jej na své zařízení pro rozšířené využití a snadný přístup.`,
'sc16e00a7a8b2fde2': `Zpět`,
'scdaf4bbff76674c8': `Přidat na plochu`,
'se0e473adfda8066c': `Otevřete v hlavním prohlížeči`,
'se740f75b95a51807': `Přidejte jej do svého Docku pro rozšířené využití a snadný přístup.`,
'sfea652f6580ff086': `Tento web má funkce aplikace.`,
    };
  